import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EngineerRecommendationsListComponent } from './engineer-recommendations-list.component';

const routes: Routes = [
  {
    path: '',
    component: EngineerRecommendationsListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EngineerRecommendationsListRoutingModule {}
